<template>
  <v-card tile>
    <v-toolbar card dark color="primary">
      <v-btn icon @click.native='close' dark>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Edit Invitation</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click.native="save">Save</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <v-form v-if="formData">
        <v-layout row justify-space-around>
          <v-flex ma-3>
            <v-card ma-2 class="elevation-4">
              <v-flex pa-3>
                <v-layout row wrap>
                  <v-flex xs6>
                    <content-field
                      v-model="formData.invitationName"
                      label="Invitation name"
                    />
                  </v-flex>

                </v-layout>
                <v-layout column wrap>
                  <h3>Unique link</h3>
                  <v-flex xs6 class="mb-3">
                    {{ `${eventLink}registration/${formData.slug}/${formData.code}` }}
                  </v-flex>
                </v-layout>
                <v-layout column wrap v-if="isPaymentTypeGroup" class="pb-3">
                  <h3>Attendees registered and paid by the invitation</h3>
                  <div v-if="formData.attendeesWithGroupPaymentType.length">
                    <div
                      v-for="(attendee, index) in formData.attendeesWithGroupPaymentType"
                      :key="`attendee${index}${attendee.email}`">
                      <v-icon>done</v-icon> <b>{{attendee.firstName}} {{attendee.lastName}}</b> {{attendee.email}}
                    </div>
                  </div>
                  <div v-else>
                    Nobody has registered by the invitation yet
                  </div>
                </v-layout>
                <v-layout column wrap class="pb-3">
                  <h3>Attendees registered by the invitation</h3>
                  <div v-if="hasRegisteredVipAttendees">
                    <div
                      v-for="(attendee, index) in formData.registeredVipAttendees"
                      :key="`attendee${index}${attendee.id}`">
                      <v-icon>done</v-icon>{{attendee.email}}
                    </div>
                  </div>
                  <div v-else>
                    Nobody has registered by the invitation yet
                  </div>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs6>
                    <content-editor
                      v-model="formData.description"
                      label="Description"
                      placeholder="Write invitation description"
                    />
                  </v-flex>
                </v-layout>
                <!--<v-layout row wrap>-->
                  <!--<v-flex xs6>-->
                    <!--<content-field-->
                      <!--v-model="formData.blitzUserEmail"-->
                      <!--label="Blitz user email"-->
                      <!--type="email"-->
                      <!--:error="$v.formData.blitzUserEmail"-->
                    <!--/>-->
                  <!--</v-flex>-->
                <!--</v-layout>-->
                <!--<v-layout row wrap>-->
                  <!--<v-flex xs6>-->
                    <!--<content-field-->
                      <!--v-model="formData.blitzUserName"-->
                      <!--label="Blitz user name"-->
                    <!--/>-->
                  <!--</v-flex>-->
                <!--</v-layout>-->
                <v-layout row wrap>
                  <v-flex xs6>
                    <content-field
                      v-model="formData.superUserEmail"
                      label="Super user email"
                      type="email"
                      :error="$v.formData.superUserEmail"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs6>
                    <content-field
                      v-model="formData.superUserMessagesCount"
                      label="Super user messages count"
                      type="number"
                      :error="$v.formData.superUserMessagesCount"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs6>
                    <content-field
                      v-model="formData.boothNumber"
                      label="Booth number"
                      type="number"
                    />
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-flex xs3>
                    <v-checkbox
                      v-model="formData.isSponsor"
                      label="Is sponsor"
                    />
                  </v-flex>
                  <v-flex xs3>
                    <v-checkbox
                      v-model="formData.isKillerFeatureEnabled"
                      label="Is killer feature enabled"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-select
                      :items="filteredCategories"
                      v-model="formData.categoryId"
                      item-text="name"
                      item-value="id"
                      abel="Category"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-select
                      v-model="formData.attendeeTypeId"
                      :items="getVIPAttendeeTypes"
                      item-text="title"
                      item-value="id"
                      label="Vip attendee type"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-card>
          </v-flex>
        </v-layout>
      </v-form>

    </v-card-text>
  </v-card>
</template>

<script>
import ContentField from '@/components/shared/ContentField'
import ContentEditor from '@/components/shared/ContentEditor'
import { mapGetters, mapActions } from 'vuex'
import { required, minValue, numeric, email } from 'vuelidate/lib/validators'
import { clone, path} from 'ramda'

export default {
  name: 'EditInvitationForm',
  components: {
    ContentField,
    ContentEditor
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      formData: null,
      allCategories: [],
      filteredCategories: []
    }
  },
  computed: {
    ...mapGetters([
      'eventLink',
      'getVIPAttendeeTypes',
      'categoriesList'
    ]),
    isPaymentTypeGroup () {
      return this.formData.paymentType === 'Group'
    },
    hasRegisteredVipAttendees () {
      return this.formData.registeredVipAttendees.length > 0
    }
  },
  watch: {
    item () {
      this.formData = this.item
    },
    'formData.categoryType'() {
      this.filterAllCategories()
    },
    categoriesList: {
      handler: function (newVal) {
        this.allCategories = clone(newVal)
        this.filterAllCategories()
      },
      deep: true
    }
  },
  validations: {
    formData: {
      id: { required },
      attendeeTypeId: { required },
      superUserMessagesCount: { numeric, minValue: minValue(0)},
      blitzUserEmail: { email },
      superUserEmail: { email }
    }
  },
  methods: {
    ...mapActions([
      'fetchVIPAttendeeTypes',
      'updateVipInvitation',
      'getCategoriesList'
    ]),
    async save () {
      this.$v.$touch()
      if (this.$v.formData.$invalid) return
      if (!path(['superUserEmail'], this.formData)) {
        this.formData.superUserEmail = null
      }
      await this.updateVipInvitation(this.formData)
      this.$emit('edit', 'editInvitation')
      this.close()
    },
    close () {
      this.$emit('close')
    },
    filterAllCategories () {
      this.filteredCategories = this.allCategories.filter((category) => {
        return category.categoryType === 'None' && category.type === path(['categoryType'], this.formData)
      })
    },
    async receiveRequiredData() {
      await Promise.all([
        this.fetchVIPAttendeeTypes(),
        this.getCategoriesList()
      ])
    }
  },
  created () {
    this.receiveRequiredData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/VipInvitation/editInvitationForm.vue